import { CopyToClipboardIcon, SuccessModalIcon } from '../../../assets/Icon';
import Voucher1 from '../../../assets/voucher1.png';
import Modal from '../../common/modal/Modal';
import Button from '../../ui/Button';
import styles from './style.module.scss';

type BuyVoucherSuceessProps = {
  open: boolean;
  onClose: () => void;
};

const BuyVoucherSuceessModal = ({ onClose, open }: BuyVoucherSuceessProps) => {
  return (
    <Modal open={open} onClose={onClose} isCloseIconVisible={false}>
      <div className={styles.wrapper}>
        <div className={styles.iconWrapper}>
          <img src={Voucher1} alt="voucher-image" />
          <SuccessModalIcon size={55} />
        </div>
        <p className={styles.title}>Your Voucher is ready to use</p>
        <div className={styles.codeWrapper}>
          <span>Coupon ID: ZEEVO24</span>
          <CopyToClipboardIcon />
        </div>
        <div className={styles.actions}>
          <Button variant="outline" onClick={onClose}>
            Close
          </Button>
          <Button variant="dark">Download</Button>
        </div>
      </div>
    </Modal>
  );
};

export default BuyVoucherSuceessModal;
